import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work3MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail11 from './image/workThumbnails/thumbnail11.webp';
import OpenButton from './components/OpenButton';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//StoreUXUIDesign

function Work3(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'Store UX/UI Design - Lynkim',
      description: 'Mobile store tap UX/UI design on Styleshare to maximize store tap using rates and purchase amout.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'Store UX/UI Design'} 
          description={'Mobile store tap UX/UI design on Styleshare to maximize store tap using rates and purchase amout.'} 
          team={'Styleshare'} 
          role={'Service Planning, UXUI Design'} 
          period={'2020.10 - 2020.12.'}
          titleKo={'스토어 탭 UX/UI 디자인'}
          descriptionKo={'스타일쉐어 모바일 스토어 탭 사용률과 구매 전환을 높이기 위한 UX/UI를 설계했습니다.'}
          teamKo={'스타일쉐어(Styleshare)'}
          roleKo={'서비스 기획, UXUI 디자인'}
          showButton={true}
          buttonLabel="View Project"
          buttonHref="https://www.figma.com/proto/iQ9Tgs7kQgjO6waM0oealt/%ED%8F%AC%ED%8A%B8%ED%8F%B4%EB%A6%AC%EC%98%A4-%EC%9B%B9?page-id=318%3A17733&node-id=318-19164&viewport=301%2C471%2C0.05&t=zsUXHmmBb8vAF2kP-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=318%3A19164"/>
      </div>
      <MainImage image={mainImage}/>
      <NextItem to='/Work11' thumbnail={thumbnail11} nextProjectTitle='Improvement the mission contents UX'/>
      {/* <Waiting/> */}
      {/* <WorkTextSection description={<div>Please click <b>"View Project"</b> button to read contents</div>}/> */}
      
      <BackButton/>
      <div style={{ height: "400px" }} />
      
      </>
      // </ProtectedPage>
    )
}

export default Work3;
